

export const ASL_3 = {
    codice: '070103',
    descr: 'ASL 3',
    domicilio: true
}
export const ASL_5 = {
    codice: '070105',
    descr: 'ASL 5',
    domicilio: true
}

export const isDomicilioAttivo = (codiceAsl) => {
    switch (codiceAsl) {
        case ASL_3.codice:
            return ASL_3.domicilio
        case ASL_5.codice:
            return ASL_5.domicilio
        default:
            return false
    }
}
